import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';

import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, setSaleType, reportDWH } from '../saleJetBlockSlice';
import { setDefaultConverter, getCustomerAddresses } from '../saleBlockAsyncThunk';
import ViewingOption from '../Partials/ViewingOption/ViewingOption';

const ViewingOptionPage = (props) => {
    const [errorMsg, setErrorMsg] = useState('');
    const [viewingOption, setViewingOption] = useState('');

    useEffect(() => {
        props.reportDWH({ actionType: 'Converters YoN', status: 'Ongoing', messageText: 'Converters YoN Page Displayed' });
    }, []);

    //page params
    let isDisplayFooter = true;
    let btnText = 'המשך';
    let currentPageFunction = handlePageContinue;
    let totalPrice = null;
    let priceText = '';
    let formid = 'saleJet';
    //page params

    let currentPageHeadline = (
        <div className='page-headline-wrapper'>
            <h1 className='sale-title'></h1>
            <h1 className='sale-title-big'> תצטרכו ממיר כדי לצפות ב{window.Config.brand_Name_HE} TV? </h1>
            <h2 className='sale-title-small'> במכשירים חכמים ניתן לצפות באמצעות האפליקציה </h2>
        </div>
    );

    let currentPageView = (
        <ViewingOption onSelectedViewingOption={handleSelectedViewingOption} supportedTvImage={props.supportedTvImage} supportedTvPopupText={props.supportedTvPopupText} errorMsg={errorMsg} />
    );

    return (
        <div className='slideAnimation'>
            {currentPageHeadline}
            <div className='sale-page-content'>
                <form noValidate id='sale' onSubmit={handleSubmit}>
                    {currentPageView}
                </form>
                <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
            </div>
        </div>
    );

    function handleSelectedViewingOption(viewingOption) {
        setViewingOption(viewingOption);
        setErrorMsg('');
    }

    function handlePageContinue() {
        if (!viewingOption) {
            setErrorMsg('אנא בחר אחת מן מהאפשרויות');
            return;
        }

        props.setSaleType(viewingOption);
        if (viewingOption == 'tv') {
            //props.goToPage('convertersPage');
            props.setDefaultConverter();
        }
        else {
          props.reportDWH({ actionType: 'Converters YoN', status: 'Ongoing', messageText: 'Converters YoN Page Button Clicked' });
            if(props.isHidePremiumPackagesPage){
                if (props.addons?.length >= 1){
                  props.goToPage('addonsPage');
                }else if (props.flowType == 'existsCustomer') {
                  props.getCustomerAddresses();
                }
                else {
                  props.goToPage('personalInfoPage');
                }
            }else{
                props.goToPage('premiumPackagesPage');
            }
        }
    }

    function handleSubmit(event) {
        event.preventDefault();
    }

};

const mapStateToProps = (state) => {
    return {
        saleType: state.saleJetBlock.saleType,
        offerName: state.saleJetBlock.offerName,
        supportedTvImage: state.saleJetBlock.saleBlockData.supportedTvImage,
        supportedTvPopupText: state.saleJetBlock.saleBlockData.supportedTvPopupText,
        isHidePremiumPackagesPage: state.saleJetBlock.saleBlockData.isHidePremiumPackagesPage,
        addons: state.saleJetBlock.saleCatalog?.addons,
        flowType: state.saleJetBlock.flowType

        //other states
    };
};

const mapDispatchToProps = {
    goToPage,
    setSaleType,
    reportDWH,
    setDefaultConverter,
    getCustomerAddresses
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewingOptionPage);